import {Directive, inject, Input, TemplateRef} from '@angular/core';
import {TabsComponent} from '@shared/controls/tabs/tabs/tabs.component';

@Directive({selector: '[plTabBody]'})
export class TabBodyDirective {
  private tabs = inject(TabsComponent);

  templateRef = inject(TemplateRef);

  @Input('plTabBody') name = '';
}
